import React, { useState,useEffect } from 'react';
import axios from 'axios';
import './MoreInfoSection.css';

import BeatLoader from "react-spinners/SyncLoader";
import PropagateLoader  from "react-spinners/HashLoader";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const CourseInfoRequest = ({courseID}) => {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [course, setCourse] = useState('');
  const [Coursecode, setCoursecode] = useState('');
  const [message, setMessage] = useState('');
  const [courses, setCourses] = useState();
  const [Loading, setLoading] = useState(false);
  
  



   //pull courses
   useEffect(()=>{
    async function getCourses (){                    
       try{                              
         const response =   await axios.get(process.env.REACT_APP_BASEURL+'/api/courses/')

                    if(response && response?.status == 200){     
                      console.log("COURSES INFRO",response?.data)               
                        setCourses(response?.data);
      
                    }

       }catch(e){
             // console.log("catch error",e)
       }
                   
    }                
      
     getCourses()                  

 },[])



  

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true)

    try {
      const response = await axios.post(process.env.REACT_APP_BASEURL + "/sendmail", {
        email,
        firstName,
        course,
        Coursecode
      });

      setLoading(false)
      toast.success("Email sent successfully!");
      
      setMessage(response.data.message || 'Email sent successfully!');
    } catch (error) {
      setLoading(false)
      //console.error('Error sending email:', error);
      toast.success('Error sending email:', error);
      setMessage('Failed to send email. Please try again later.');
    }
  };

  

  return ( 
        <>  

{courses && courses.map((course,index)=>{

        return(
          <>  


         {course?.CourseCode == courseID &&

          <div className="info-section" id='info'>
          <div className="info-container">
            {/* <h2 className="info-title">Get more {`${(course?.CourseName).toLowercase()} `}Information</h2> */}
            <h2 className="info-title">Get more {`${(course?.CourseName).toLowerCase()} `}information</h2>

            <p className="info-description">
              Enter your details to receive a detailed course brochure and more information on the course.
            </p>
            <form onSubmit={handleSubmit} className="info-form">
              <div className="form-group">
                <label htmlFor="firstName" className="form-label">Full Name</label>
                <input
                  disabled={Loading}
                  type="text"
                  id="firstName"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  className="form-input"
                  placeholder="Enter your full name"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email" className="form-label">Email Address</label>
                <input
                  
                  disabled={Loading}
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                  placeholder="Enter your email"
                  required
                />
              </div>
              <button onClick={()=>{
                   setCourse(course?.CourseName)
                   setCoursecode(course?.CourseCode)
                               console.log("clicked course",course?.CourseCode)}
                         
              } type="submit" className="info-button">  

                                {Loading ? (
                                      <BeatLoader size={6} color="white" className='beatloader' />
                                      ) : (
                                      <p>
                                          Request Info
                                      </p>
                                      )}

                                      <ToastContainer/>
                
                </button>
              {message && <p className="form-message">{message}</p>}
            </form>
          </div>
        </div>

         }

          
          
          </>
        )

  })}
   
      
        </>

    
  );
};

export default CourseInfoRequest;
